import React, { FC, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Controller } from 'react-hook-form';
import ReactSelect from 'react-select';

import classes from '../CustomFormComponents.module.css';
import classNames from 'classnames';

interface SelectProps {
	control: any;
	intl: any;
	errors: any;
	label: string;
	name: string;
	options: { label: string; value: string }[];
	disabled?: boolean;
	initializedValue?: string;
	menuPlacement?: 'auto' | 'bottom' | 'top' | undefined;
	marginLess?: boolean;
	required?: boolean;
	standardInput?: boolean;
}

const Select: FC<SelectProps> = SelectProps => {
	const {
		control,
		intl,
		errors,
		label,
		name,
		options,
		disabled,
		initializedValue,
		menuPlacement,
		marginLess,
		required,
		standardInput,
	} = SelectProps;

	const [selectedValue, setSelectedValue] = useState(initializedValue);

	const styles = {
		control: () => ({
			display: 'flex',
		}),
		indicatorSeparator: () => ({ display: 'none' }),
		option: (provided: any, state: any) => ({
			...provided,
			fontSize: '15px',
			color: 'var(--ion-text-color)',
			backgroundColor: state.isFocused ? 'var(--form-field-hover-color)' : null,
		}),
		singleValue: (provided: any, state: any) => {
			const opacity = state.isDisabled ? 0.5 : 1;
			const transition = 'opacity 300ms';

			return { ...provided, opacity, transition, fontSize: '15px', marginLeft: 0 };
		},
		valueContainer: (provided: any, state: any) => ({
			...provided,
			padding: '0',
		}),
	};

	const defaultValue = initializedValue
		? options.find(option => option.value === initializedValue)
		: null;

	let errorMessage = null;
	if (errors && errors[name] && errors[name].type === 'required') {
		errorMessage = (
			<p className={classes.errorMessage}>
				{intl.formatMessage({
					id: 'LanguageOptionsMeta.required', // TODO
				})}
			</p>
		);
	}

	const requiredIndicator = required ? (
		<span className={classes.requiredIndicator}>*</span>
	) : null;

	const containerClasses = classNames({
		[classes.container]: true,
		[classes.containerStandardInput]: Boolean(standardInput),
		[classes.containerMarginLess]: Boolean(marginLess),
		[classes.containerError]: Boolean(errorMessage),
		[classes.containerSelected]: Boolean(selectedValue),
		[classes.containerDisabled]: Boolean(disabled),
	});

	const labelElm = standardInput ? null : (
		<div className={classes.label}>
			{label}
			{requiredIndicator}
		</div>
	);

	return (
		<div className={containerClasses}>
			{labelElm}
			<Controller
				className={classes.controller}
				as={ReactSelect}
				control={control}
				onChange={([selectedValue]) => {
					setSelectedValue(selectedValue.value);
					return selectedValue;
				}}
				rules={required ? { required: true } : {}}
				styles={styles}
				options={options}
				menuPlacement={menuPlacement ? menuPlacement : 'auto'}
				name={name}
				placeholder=""
				isDisabled={disabled}
				defaultValue={defaultValue}
			/>
			{errorMessage}
		</div>
	);
};

export default injectIntl(Select);
